import { isBrowser } from "shared/lib";
import { BackApi } from "./back";

export const api = new BackApi();

if (isBrowser()) {
  (window as any).api = api;
}
